export default __webpack_public_path__ + "static/media/logotype.dc80675a.svg";